import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const useEEOCCycle = (enabled) => {
    const { api } = useAuth();
    const [cycle, setCycle] = useState(null);

    const refresh = useCallback(() => {
        api.get('/eeoc-training/my/cycle').then(({ data }) => setCycle(data)).catch(() => {});
    }, [api]);

    useEffect(() => {
        if (!enabled) return undefined;
        refresh();
        const interval = setInterval(refresh, 60000);
        window.addEventListener('focus', refresh);
        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', refresh);
        };
    }, [enabled, refresh]);

    return enabled ? cycle : null;
};

export const isEEOCEligible = (user, isAdmin) => Boolean(user) && (isAdmin
    || (user.feature_access?.staffing_training !== false && user.feature_access?.eeoc_training !== false));
